import theme from "@/styles/theme";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import {
  FormControl,
  MenuItem,
  Select,
  Tooltip,
  Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import InputLabel from "@mui/material/InputLabel";
import { useEffect, useState } from "react";

const select = {
  "& .MuiFilledInput-root": {
    padding: ".1875rem 0 .1875rem 1rem",
    minHeight: "42px",
    "& ::placeholder": {
      color: "#1a1a1a",
      opacity: "1!important",
      textTransform: "uppercase",
      fontSize: "1rem",
    },

    "& input": {
      padding: "unset !important",
    },
  },

  "& label": {
    display: "none",
  },

  "& .Mui-disabled": {
    pointerEvents: "all !important",
    cursor: "not-allowed !important",
  },
};

export default function SelectStyled({
  name,
  label,
  hint,
  labelhint,
  placeholder,
  onChange,
  required = false,
  children,
  defaultValue,
  value,
  menuProps,
  tooltip,
  disabled = false,
  allowEmpty = false,
  renderValue,
}) {
  const [isValid, setIsValid] = useState(!required);
  const [answer, setAnswer] = useState(value ?? defaultValue ?? "");

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuPropOptions = {
    LimitHeight: {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        },
      },
    },
  };

  useEffect(() => {
    setAnswer(value ?? "");
  }, [value]);

  useEffect(() => {
    if (!required) {
      setIsValid(true);
    }

    setIsValid(answer || false);
  }, []);

  // Check validation on answer changed
  useEffect(() => {
    if (required) {
      setIsValid(answer ?? false);
    } else {
      setIsValid(true);
    }
  }, [answer]);

  const handleSelected = (event) => {
    setAnswer(event.target.value);
    if (onChange) {
      onChange(event, event.target.value.value);
    }
  };

  return (
    <>
      {label && (
        <InputLabel
          htmlFor={name}
          sx={{
            color: disabled
              ? theme.palette.text.disabled
              : isValid
                ? theme.palette.common.black
                : theme.palette.error.main,
          }}
        >
          {label}
          {required && "*"} {labelhint && <span>({labelhint})</span>}
          <Typography
            variant="caption"
            component="span"
            sx={{
              "&.MuiTypography-root": {
                color: isValid ? grey[600] : theme.palette.error.main,
              },
            }}
          >
            {hint}
          </Typography>
          {tooltip && (
            <Tooltip title={tooltip}>
              <HelpOutlineIcon
                color="secondary"
                sx={{ fontSize: "1rem", transform: "translate(.5rem, .15rem)" }}
              />
            </Tooltip>
          )}
        </InputLabel>
      )}
      <FormControl
        variant="filled"
        sx={{
          width: "100%",
          "&.MuiFormControl-root": {
            background: "transparent",
          },
          "& .MuiFilledInput-root": {
            "&::before": {
              borderColor: isValid ? "transparent" : "#c33132 !important",
            },
          },
        }}
      >
        <Select
          displayEmpty={true}
          required={required}
          renderValue={
            renderValue ??
            (answer !== ""
              ? () => <>{typeof answer === "object" ? answer.label : answer}</>
              : () => <>{placeholder ? placeholder : "Bitte wählen"}</>)
          }
          name={name}
          sx={select}
          onChange={handleSelected}
          defaultValue={defaultValue}
          value={value}
          disabled={disabled}
          MenuProps={MenuPropOptions[menuProps] || {}}
        >
          {allowEmpty && <MenuItem value="">Bitte wählen</MenuItem>}
          {children}
        </Select>
      </FormControl>
    </>
  );
}
